const testIds = {
  global: {
    header: {
      logo: "header-logo",
      navigation: {
        toggle: "header-navigation-toggle",
        menu: {
          container: "header-navigation-menu-container",
          item: "header-navigation-menu-item",
        },
      },
    },
    footer: {
      officeList: {
        link: "footer-office-list-link",
        title: "footer-office-list-title",
        office: "footer-office",
      },
      socialMedia: {
        title: "footer-social-media-title",
        icon: "footer-social-media-icon",
      },
      legal: {
        copyright: "footer-legal-copyright",
        link: "footer-legal-link",
      },
    },
  },
  components: {
    header: {
      title: "header-title",
    },
    filter: {
      item: "filter-item",
    },
    contentList: {
      item: {
        container: "content-list-item-container",
        title: "content-list-item-title",
      },
    },
  },
}

const formIds = {
  contact: "7a027c76-c470-4777-9ad9-b9b534f596bc",
}

const COOKIEBOT_DECLARATION_WRAPPER_ID = "cookiebot-declaration-wrapper"

export { COOKIEBOT_DECLARATION_WRAPPER_ID, formIds, testIds }
